export default __webpack_public_path__ + "static/media/stat.198ccd6e.svg";